import {
  setUserList,
  setTagsInUsers,
  setUser,
  setCurrentUser,
  setAirports,
  selUserId,
  setCountriesInUser,
} from "./userAssignmentSlice";
// import * as R from "ramda";
import loaderClient from "api/reduxLoaderApi";
import { toast } from "react-toastify";
import { getPendUserList } from "./userThunks";

export const getAllUsers = () => async (dispatch) => {
  const link = "";
  const client = loaderClient("get")(link);
  const res = await client({})({});
  if (!res.message) return "";
  return dispatch(setUserList(res.message));
};

export const getUserById = (id) => async (dispatch) => {
  const link = "";
  const client = loaderClient("get")(link);
  const res = await client({})({});
  if (!res.message) return "";
  return dispatch(setUser({ ...res.message.user, password: "******" }));
};

export const acceptUser = (id, data) => async (dispatch) => {
  const link = `/join-requests/${id}`;

  const client = loaderClient("patch")(link);
  const res = await client(data)({});
  if (!res.message) return "";
  //return dispatch(getCurrentUserAssignments(data.user));
};
export const redjectUser =
  (id, data, callback = undefined) =>
  async (dispatch) => {
    console.log({ id, data });
    const link = `/join-requests/${id}`;
    const client = loaderClient("patch")(link);
    const res = await client(data)({});
    if (!res.message) return "";
    dispatch(getPendUserList());
    return callback && callback();
  };

export const addUserAssignments =
  (userAssignment, userId, callback = false) =>
  async () => {
    const client = loaderClient("post")(`/users/${userId}/assignments`);
    const res = await client(userAssignment)({});
    return callback && callback(res.error, res.message);
  };
